"use client";

import { ReactNode, useId } from "react";
import { Checkbox, Text, Tooltip } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

interface CheckboxConsentFieldProps {
	name: string;
	label: ReactNode;
	tooltip?: {
		infoTitle?: string;
		infoText?: string;
		placement?: "top-end" | "top" | "bottom" | "top-start";
	};
}

// The library's 1.3rem box plus the row gap: where the label text starts.
const LABEL_INDENT = "ps-[calc(1.3rem+var(--lea-spacing-1-5))]";

/** Renders its own error: the library's helper text is indented for text inputs. */
export const CheckboxConsentField = ({
	name,
	label,
	tooltip,
}: CheckboxConsentFieldProps) => {
	const errorId = useId();

	const field = (
		<FormField
			name={name}
			render={({ checkedField: { helperText, ...checkedField } }) => (
				<div>
					<Checkbox
						label={label}
						{...checkedField}
						aria-describedby={helperText ? errorId : undefined}
					/>
					{helperText && (
						<Text
							id={errorId}
							textStyle="body-sm"
							color="status.error.base"
							className={LABEL_INDENT}
						>
							{helperText}
						</Text>
					)}
				</div>
			)}
		/>
	);

	if (!tooltip?.infoText) return field;

	return (
		<Tooltip
			placement={tooltip.placement ?? "top-end"}
			title={tooltip.infoText}
		>
			<span>{field}</span>
		</Tooltip>
	);
};
